import React, { PropTypes } from 'react';
import StandardModal from 'shared/StandardModal.jsx';

const SquadDeleteConfirmModal = ({
  visible,
  onCancelClick,
  onConfirmDeleteClick,
  warningMessage,
  error,
  choices,
  confirmation
}) => (
    <StandardModal
      title="Confirm Squad Delete"
      visible={visible}
      onCloseClick={onCancelClick}>
      <div>
        {error && (
          <div className="alert alert-danger">
            {error}
          </div>
        )}
        {warningMessage && (
          <div className="alert alert-warning">
            {warningMessage}
          </div>
        )}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
          <button
            type="button"
            className="btn btn-link"
            onClick={onCancelClick}
          >{'Cancel'}</button>
          { choices && choices.length > 0 && choices.map((choice, index) => (
            <button
              key={index}
              type="button"
              className="btn btn-danger btn-lg"
              onClick={() => onConfirmDeleteClick(choice, confirmation)}
              disabled={error}
            >
              {choice}
            </button>
          ))} 
        </div>
      </div>
    </StandardModal>
);

SquadDeleteConfirmModal.propTypes = {
  title: PropTypes.string,
  visible: PropTypes.bool,
  onCancelClick: PropTypes.func,
  onConfirmDeleteClick: PropTypes.func,
  warningMessage: PropTypes.string,
  error: PropTypes.string,
  choices: PropTypes.array
};

export default SquadDeleteConfirmModal;



// WEBPACK FOOTER //
// ./src/features/tournament/squads/SquadDeleteConfirmModal.jsx